import { HOST_ORIGINAL, HOST_PUBLICO, URL_ORIGINAL } from '../dominios';

export type Entrada =
  | { tipo: 'presentacion' }
  | { tipo: 'muestra' }
  | { tipo: 'app' }
  | { tipo: 'redirigir'; destino: string };

function rutaNormalizada(pathname: string): string {
  if (pathname === '/') return '/';
  return pathname.replace(/\/+$/, '') || '/';
}

/** Decide la pantalla antes de montar componentes que consultan la API deportiva. */
export function resolverEntrada(hostname: string, pathname: string): Entrada {
  const ruta = rutaNormalizada(pathname);
  if (hostname === HOST_PUBLICO) {
    if (ruta === '/muestra') return { tipo: 'muestra' };
    if (ruta === '/grupo') return { tipo: 'redirigir', destino: URL_ORIGINAL };
    if (ruta === '/gestion') return { tipo: 'redirigir', destino: `${URL_ORIGINAL}/gestion` };
    return { tipo: 'presentacion' };
  }
  if (hostname === HOST_ORIGINAL) {
    if (ruta === '/conocer') return { tipo: 'presentacion' };
    if (ruta === '/muestra') return { tipo: 'muestra' };
    return { tipo: 'app' };
  }
  // Pilotos, workers.dev, localhost y demos conservan la entrada vigente.
  if (ruta === '/conocer') return { tipo: 'presentacion' };
  if (ruta === '/muestra') return { tipo: 'muestra' };
  return { tipo: 'app' };
}

/** Excepción de desarrollo para mantener la comodidad de la demo local. */
export function ofrecePresentacionLocal(host: string, pathname: string, instalada: boolean, conocido: boolean): boolean {
  const ruta = rutaNormalizada(pathname);
  return (host === 'localhost' || host === '127.0.0.1') && ruta === '/' && !instalada && !conocido;
}
